import { Paper, cn } from "@podcastsoundboard/ps-lib/ui"

export default function HomeCard(props: {
  children: React.ReactNode
  containerClassName?: string
  borderRadius?: string | null
}) {
  const { children, containerClassName, borderRadius } = props

  return (
    <Paper
      className={cn(
        "flex h-full min-h-[20vh] flex-col items-stretch justify-center p-4",
        containerClassName,
      )}
      style={{
        borderRadius: borderRadius ? "20px" : undefined,
      }}
    >
      {children}
    </Paper>
  )
}
